import React from 'react';
import './Testimonials.css';  

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteLeft } from 'react-icons/fa';

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules'; 
 
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles   
import 'swiper/css';  
import 'swiper/css/pagination'; 
import 'swiper/css/navigation';



const Testimonials = () => { 
  return (
    <> 
      <section className='testimonials'>

        <Heading title={'testimonials'} span={'what customers say'} />

        {/* Slider wrapper for testimonials */}
        <div className='testimonial-slider'>
        <Swiper 
          modules={[Navigation, Pagination, Autoplay]} // Enable needed Swiper modules
          spaceBetween={150} // Gap between slides
          loop={true} // Infinite loop
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4s
          navigation // Enable prev/next buttons
          pagination={{ clickable: true }} // Enable dots for navigation
        >
          {
            // Dynamically render each testimonial slide
            testiContent.map((testimonial) => {
              return (
                <SwiperSlide className='testi-item' key={testimonial.id}>

                  {/* Testimonial text content */}
                  <div className='content'>
                    <div className='comment'>
                      <FaQuoteLeft className='quote-start'/> {/* Quote icon at start */}
                      <FaQuoteLeft className='quote-end'/> {/* Quote icon at end */}
                      <p>{testimonial.content}</p> {/* Testimonial message */}
                    </div>
                    <h3>{testimonial.name}</h3> {/* Customer name */}
                    <h5>{testimonial.title}</h5> {/* Customer title/position */}
                  </div>

                  {/* Customer image */}
                  <div className='image'>
                    <img src={testimonial.image} alt='testimonial-pic' />
                  </div>

                </SwiperSlide>
              )
            })
          }

        </Swiper>
        </div>
        
      </section>
    </>

  )
} 

export default Testimonials